import React from 'react'
import { PageSkeleton } from '../Section/PageSkeleton'
import { SectionHeading } from '../Section'
import { LogoInline } from '../LogoInline'
import { Box } from '@material-ui/core'
import DateTime from 'luxon/src/datetime'
import { Content } from './TermsContent'
import { COMPANY, COMPANY_ADDRESS } from '../../company'

export function TermsOfUse() {
  const lastUpdatedAt = DateTime.local(2026, 10, 8).setLocale('pl')

  return (
    <PageSkeleton>
      <SectionHeading>
        Regulamin serwisu <LogoInline /> i świadczenia usług drogą elektroniczną
      </SectionHeading>
      <Box display="flex" justifyContent="center">
        <Content>
          <p>Obowiązuje od {lastUpdatedAt.toFormat('d MMMM yyyy')} r.</p>
          <ol>
            <li>
              Postanowienia ogólne
              <ol>
                <li>
                  Niniejszy Regulamin określa zasady i warunki korzystania z
                  Oprogramowania CelPal udostępnianego drogą elektroniczną w
                  modelu usługowym (SaaS) w Serwisach oraz zasady zawierania i
                  wykonywania Umów o korzystanie z Oprogramowania, w tym
                  udzielania licencji na Oprogramowanie. Oprogramowanie stanowi
                  w szczególności elektroniczny odpowiednik Książki Rejestru
                  Pobytu na Strzelnicy w rozumieniu rozporządzenia Ministra
                  Spraw Wewnętrznych i Administracji z dnia 15 marca 2000 r. w
                  sprawie wzorcowego regulaminu strzelnic.
                </li>
                <li>
                  Oprogramowanie i Serwisy należą do {COMPANY.name},
                  przedsiębiorcy prowadzącego jednoosobową działalność
                  gospodarczą wpisaną do Centralnej Ewidencji i Informacji o Działalności Gospodarczej, z siedzibą przy {COMPANY_ADDRESS}, NIP{' '}
                  {COMPANY.nipNumber}, adres e-mail: {COMPANY.email}, zwanego
                  dalej Licencjodawcą.
                </li>
                <li>
                  Regulamin skierowany jest wyłącznie do podmiotów niebędących
                  konsumentami: przedsiębiorców, stowarzyszeń, fundacji, klubów
                  strzeleckich i innych jednostek organizacyjnych prowadzących
                  strzelnicę lub organizujących strzelania. Korzystanie z
                  aplikacji mobilnej CelPal przez strzelców reguluje odrębny
                  Regulamin Aplikacji Mobilnej.
                </li>
                <li>
                  Regulamin jest udostępniany bezpłatnie pod adresem
                  https://celpal.net/regulamin w sposób umożliwiający jego
                  pozyskanie, odtwarzanie i utrwalanie przed zawarciem Umowy.
                </li>
              </ol>
            </li>
            <li>
              Definicje
              <ol>
                <li>
                  Serwisy - serwisy internetowe Licencjodawcy w domenach
                  celpal.net, online.celpal.net, admin.celpal.net,
                  portal.celpal.net i book.celpal.net.
                </li>
                <li>
                  Oprogramowanie - chroniony prawem autorskim program
                  komputerowy pod nazwą CelPal, udostępniany w Serwisach w
                  najnowszej dostępnej wersji wraz z elementami niebędącymi
                  programem komputerowym, lecz stanowiącymi jego integralną
                  część, służący do prowadzenia elektronicznej książki rejestru
                  pobytu na strzelnicy oraz do wykonywania pozostałych funkcji
                  opisanych na stronie https://celpal.net/produkt i w Cenniku.
                </li>
                <li>
                  Organizacja, Licencjobiorca - podmiot niebędący konsumentem w
                  rozumieniu art. 22<sup>1</sup> Kodeksu cywilnego, który zawarł
                  z Licencjodawcą Umowę i w imieniu którego korzysta z
                  Oprogramowania.
                </li>
                <li>
                  Użytkownik - osoba fizyczna korzystająca z Oprogramowania za
                  pomocą Konta w imieniu i na rzecz Organizacji, w szczególności
                  jej pracownik, członek, obsługa strzelnicy lub instruktor.
                </li>
                <li>
                  Konto - indywidualny dostęp Użytkownika do Oprogramowania,
                  chroniony adresem e-mail lub loginem i hasłem, przypisany do
                  Organizacji.
                </li>
                <li>
                  Administrator Organizacji - Użytkownik uprawniony do
                  reprezentowania Organizacji wobec Licencjodawcy, który założył
                  Konto Organizacji lub któremu nadano w Oprogramowaniu rolę
                  administratora; Administrator Organizacji zarządza Kontami
                  pozostałych Użytkowników, Pakietem i Subskrypcją.
                </li>
                <li>
                  Umowa - umowa o korzystanie z Oprogramowania zawarta między
                  Licencjodawcą a Organizacją, na którą składają się: Regulamin,
                  Umowa licencyjna oraz Umowa powierzenia, a także Cennik w
                  zakresie wybranego Pakietu.
                </li>
                <li>
                  Umowa licencyjna - umowa określająca zakres licencji na
                  Oprogramowanie udzielonej Organizacji, akceptowana przez
                  Administratora Organizacji w Serwisie online.celpal.net.
                </li>
                <li>
                  Umowa powierzenia - umowa powierzenia przetwarzania danych
                  osobowych w rozumieniu art. 28 RODO, na podstawie której
                  Licencjodawca przetwarza w imieniu Organizacji dane osobowe
                  zapisywane za pomocą Oprogramowania, akceptowana przez
                  Administratora Organizacji w Serwisie online.celpal.net.
                </li>
                <li>
                  Okres próbny - okres 30 dni od dnia rejestracji Organizacji, w
                  którym Organizacja korzysta z Oprogramowania bezpłatnie.
                </li>
                <li>
                  Pakiet - zestaw funkcji i limitów Oprogramowania udostępniany
                  Organizacji; Pakiety, ich zawartość i ceny określa Cennik.
                </li>
                <li>
                  Subskrypcja - odpłatny dostęp do wybranego Pakietu, rozliczany
                  cyklicznie w Okresach rozliczeniowych.
                </li>
                <li>
                  Okres rozliczeniowy - miesiąc kalendarzowy liczony od dnia
                  rozpoczęcia Subskrypcji, chyba że Cennik lub umowa
                  indywidualna przewidują inny okres.
                </li>
                <li>
                  Cennik - aktualny wykaz Pakietów, ich funkcji, limitów i cen,
                  dostępny pod adresem https://celpal.net/cennik oraz w
                  Oprogramowaniu w panelu Subskrypcji.
                </li>
                <li>
                  Operator płatności - Stripe Payments Europe, Ltd., za
                  pośrednictwem którego Licencjodawca pobiera opłaty za
                  Subskrypcję.
                </li>
                <li>
                  Wymagania techniczne - urządzenie z dostępem do Internetu i
                  aktualną wersją przeglądarki Google Chrome, Mozilla Firefox,
                  Apple Safari lub Microsoft Edge; do prowadzenia książki
                  rejestru pobytu z własnoręcznym podpisem strzelca - urządzenie
                  z ekranem dotykowym; do korzystania z aplikacji mobilnej -
                  urządzenie z systemem Android lub iOS w wersji wskazanej w
                  sklepie z aplikacjami.
                </li>
              </ol>
            </li>
            <li>
              Zawarcie Umowy
              <ol>
                <li>
                  Umowa zostaje zawarta drogą elektroniczną, gdy łącznie:
                  <ol>
                    <li>
                      osoba uprawniona do reprezentowania Organizacji
                      zarejestruje Organizację w Serwisie online.celpal.net,
                      podając swoje imię, nazwisko, adres e-mail i hasło,
                      akceptuje Regulamin oraz zapoznaje się z Polityką
                      prywatności, a następnie aktywuje Konto za pomocą linku
                      przesłanego na podany adres e-mail;
                    </li>
                    <li>
                      Administrator Organizacji poda w Oprogramowaniu dane
                      rejestrowe Organizacji (pełną nazwę, adres siedziby, NIP,
                      a w razie posiadania także KRS i REGON) oraz zaakceptuje
                      Umowę licencyjną i Umowę powierzenia.
                    </li>
                  </ol>
                </li>
                <li>
                  Do czasu wykonania czynności z pkt 3.1 lit. B Organizacja i
                  jej Użytkownicy nie mogą korzystać z Oprogramowania poza
                  ekranem służącym do ich wykonania.
                </li>
                <li>
                  Osoba rejestrująca Organizację i akceptująca Umowy oświadcza,
                  że jest umocowana do zawarcia Umowy w imieniu Organizacji, a
                  podane dane są prawdziwe i aktualne. Licencjodawca może
                  weryfikować dane Organizacji w publicznych rejestrach i
                  wstrzymać świadczenie usług do czasu wyjaśnienia rozbieżności.
                </li>
                <li>
                  Umowa może zostać zawarta także przez podpisanie przez Strony
                  dokumentu umowy lub przyjęcie indywidualnej oferty
                  Licencjodawcy. W razie sprzeczności między tak zawartą umową a
                  Regulaminem pierwszeństwo mają postanowienia umowy
                  indywidualnej; w pozostałym zakresie Regulamin wiąże Strony.
                </li>
                <li>Umowa zostaje zawarta na czas nieokreślony.</li>
              </ol>
            </li>
            <li>
              Okres próbny
              <ol>
                <li>
                  Z chwilą zawarcia Umowy Organizacja uzyskuje bezpłatny dostęp
                  do Oprogramowania w ramach Pakietu wskazanego w Cenniku jako
                  pakiet Okresu próbnego, na 30 dni od dnia rejestracji. Okres
                  próbny nie wymaga podania karty płatniczej ani wykupienia
                  Subskrypcji.
                </li>
                <li>
                  Jeżeli przed upływem Okresu próbnego Organizacja nie wykupi
                  Subskrypcji, dostęp do Oprogramowania zostaje ograniczony do
                  Pakietu bezpłatnego o funkcjach i limitach określonych w
                  Cenniku. Dane Organizacji nie są w tym momencie usuwane;
                  Organizacja może w każdej chwili wykupić Subskrypcję.
                </li>
                <li>
                  Każda Organizacja może skorzystać z Okresu próbnego tylko raz.
                  Licencjodawca może odmówić Okresu próbnego lub go skrócić
                  Organizacji, która zarejestrowała się ponownie w celu obejścia
                  tego ograniczenia.
                </li>
              </ol>
            </li>
            <li>
              Subskrypcja i płatności
              <ol>
                <li>
                  Administrator Organizacji wykupuje Subskrypcję wybranego
                  Pakietu w Oprogramowaniu, podając dane karty płatniczej u
                  Operatora płatności. Licencjodawca nie przechowuje danych kart
                  płatniczych.
                </li>
                <li>
                  Opłata za Subskrypcję jest pobierana z góry za każdy Okres
                  rozliczeniowy w wysokości wynikającej z Cennika obowiązującego
                  w dniu wykupienia Subskrypcji lub zmiany Pakietu. Ceny w
                  Cenniku są cenami netto; do ceny doliczany jest podatek VAT w
                  obowiązującej stawce.
                </li>
                <li>
                  Subskrypcja odnawia się automatycznie na kolejne Okresy
                  rozliczeniowe, do czasu jej anulowania przez Organizację lub
                  rozwiązania Umowy.
                </li>
                <li>
                  Za każdy Okres rozliczeniowy Licencjodawca wystawia fakturę
                  VAT w formie elektronicznej, na dane Organizacji podane w
                  Oprogramowaniu, i udostępnia ją w Oprogramowaniu oraz przesyła
                  na adres e-mail Organizacji. Organizacja wyraża zgodę na
                  otrzymywanie faktur w formie elektronicznej.
                </li>
                <li>
                  Administrator Organizacji może w Oprogramowaniu zmienić
                  Pakiet. Przejście na Pakiet droższy następuje natychmiast, a
                  różnica w cenie za pozostałą część Okresu rozliczeniowego jest
                  rozliczana proporcjonalnie. Przejście na Pakiet tańszy
                  następuje z początkiem kolejnego Okresu rozliczeniowego.
                </li>
                <li>
                  Administrator Organizacji może w każdej chwili anulować
                  Subskrypcję w Oprogramowaniu. Anulowanie staje się skuteczne z
                  końcem bieżącego Okresu rozliczeniowego; do tego czasu
                  Organizacja zachowuje dostęp do Pakietu, a opłata za
                  rozpoczęty Okres rozliczeniowy nie podlega zwrotowi. Po
                  anulowaniu dostęp zostaje ograniczony do Pakietu bezpłatnego.
                </li>
                <li>
                  Jeżeli pobranie opłaty nie powiedzie się, Operator płatności
                  ponawia próbę, a Licencjodawca informuje Organizację e-mailem.
                  Jeżeli opłata nie zostanie uregulowana w ciągu 14 dni od dnia
                  jej wymagalności, Licencjodawca może ograniczyć dostęp do
                  Pakietu bezpłatnego do czasu zapłaty, a po kolejnych 30 dniach
                  - anulować Subskrypcję.
                </li>
                <li>
                  Licencjodawca może zmienić Cennik. O podwyższeniu ceny
                  Pakietu, z którego Organizacja korzysta, Licencjodawca
                  informuje Administratora Organizacji e-mailem co najmniej 30
                  dni przed jej wejściem w życie. Nowa cena obowiązuje od
                  pierwszego Okresu rozliczeniowego rozpoczynającego się po tym
                  terminie; Organizacja, która nie akceptuje nowej ceny, może do
                  tego czasu anulować Subskrypcję.
                </li>
              </ol>
            </li>
            <li>
              Licencja
              <ol>
                <li>
                  Na podstawie Umowy licencyjnej Licencjodawca udziela
                  Organizacji niewyłącznej, nieprzenoszalnej, niezbywalnej
                  licencji na korzystanie z Oprogramowania w zakresie funkcji
                  Pakietu, na czas trwania Umowy, na potrzeby prowadzonej przez
                  Organizację działalności, w tym prowadzenia strzelnicy i
                  organizowania strzelań.
                </li>
                <li>
                  Licencja obejmuje prawo korzystania z Oprogramowania przez
                  Użytkowników Organizacji, w liczbie i na zasadach wynikających
                  z Pakietu, za pośrednictwem Serwisów i aplikacji mobilnej.
                  Licencja nie obejmuje prawa do wykonywania zależnych praw
                  autorskich do Oprogramowania ani praw do znaków towarowych
                  Licencjodawcy.
                </li>
                <li>
                  Organizacja i jej Użytkownicy nie mogą:
                  <ol>
                    <li>
                      kopiować, rozpowszechniać, wynajmować, publikować,
                      modyfikować, tłumaczyć Oprogramowania ani udzielać
                      sublicencji, w tym udostępniać Oprogramowania osobom
                      trzecim jako usługi;
                    </li>
                    <li>
                      odtwarzać kodu źródłowego, dekompilować ani dezasemblować
                      Oprogramowania ani tworzyć na jego podstawie dzieł
                      pochodnych, poza zakresem dozwolonym bezwzględnie
                      obowiązującymi przepisami;
                    </li>
                    <li>
                      omijać zabezpieczeń Oprogramowania, limitów Pakietu ani
                      mechanizmów kontroli dostępu, w szczególności współdzielić
                      Konta między Użytkownikami;
                    </li>
                    <li>
                      korzystać z Oprogramowania w sposób sprzeczny z prawem, z
                      jego przeznaczeniem lub naruszający prawa osób trzecich,
                      ani dostarczać za jego pomocą treści bezprawnych;
                    </li>
                    <li>
                      prowadzić zautomatyzowanego pobierania danych z Serwisów
                      poza funkcjami eksportu udostępnionymi w Oprogramowaniu.
                    </li>
                  </ol>
                </li>
                <li>
                  Do elementów Oprogramowania niebędących programem komputerowym
                  (grafiki, teksty, dokumentacja) stosuje się przepisy prawa
                  autorskiego o utworach; licencja na nie udzielana jest w
                  zakresie niezbędnym do korzystania z Oprogramowania zgodnie z
                  Umową.
                </li>
              </ol>
            </li>
            <li>
              Konta i Użytkownicy
              <ol>
                <li>
                  Konto Użytkownika powstaje przez rejestrację samego
                  Użytkownika, który dołącza do Organizacji za pośrednictwem
                  Serwisów lub aplikacji mobilnej, albo zostaje utworzone przez
                  Administratora Organizacji. Administrator Organizacji nadaje
                  Użytkownikom role i uprawnienia oraz odbiera dostęp, w tym
                  niezwłocznie po zakończeniu współpracy Użytkownika z
                  Organizacją.
                </li>
                <li>
                  Użytkownik zobowiązany jest chronić dane logowania i nie
                  udostępniać ich innym osobom. O podejrzeniu nieuprawnionego
                  dostępu do Konta należy niezwłocznie powiadomić Licencjodawcę.
                </li>
                <li>
                  Działania i zaniechania Użytkowników traktowane są jak
                  działania i zaniechania Organizacji. Organizacja odpowiada za
                  treści i dane wprowadzane do Oprogramowania przez jej
                  Użytkowników oraz za zgodność z prawem ich przetwarzania.
                </li>
                <li>
                  Organizacja zobowiązuje się korzystać z Oprogramowania na
                  sprzęcie spełniającym Wymagania techniczne. Licencjodawca nie
                  odpowiada za nieprawidłowe działanie Oprogramowania wynikające
                  z niespełnienia Wymagań technicznych, z ustawień sieci
                  Organizacji ani z działania oprogramowania osób trzecich.
                </li>
              </ol>
            </li>
            <li>
              Obowiązki i oświadczenia Licencjodawcy
              <ol>
                <li>
                  Licencjodawca zapewnia dostęp do Oprogramowania przez całą
                  dobę, z zastrzeżeniem przerw technicznych niezbędnych do
                  konserwacji, aktualizacji lub usuwania awarii. O planowanych
                  przerwach trwających dłużej niż godzinę Licencjodawca
                  informuje w Oprogramowaniu lub e-mailem z wyprzedzeniem;
                  przerwy planowane są w miarę możliwości w godzinach nocnych.
                </li>
                <li>
                  Licencjodawca w okresie trwania Umowy:
                  <ol>
                    <li>
                      udostępnia aktualizacje Oprogramowania i dostosowuje je do
                      obowiązujących przepisów prawa;
                    </li>
                    <li>
                      usuwa błędy i awarie Oprogramowania, z wyłączeniem skutków
                      działań Organizacji lub jej Użytkowników;
                    </li>
                    <li>
                      wykonuje kopie zapasowe danych i dba o integralność bazy
                      danych;
                    </li>
                    <li>
                      świadczy pomoc techniczną pod adresem kontakt@celpal.net w
                      dni robocze.
                    </li>
                  </ol>
                </li>
                <li>
                  Licencjodawca oświadcza, że przysługują mu autorskie prawa
                  majątkowe do Oprogramowania w zakresie niezbędnym do
                  udzielenia licencji oraz że Oprogramowanie jest wolne od wad
                  prawnych.
                </li>
                <li>
                  Licencjodawca może rozwijać Oprogramowanie, w tym zmieniać,
                  dodawać i wycofywać poszczególne funkcje, o ile nie prowadzi
                  to do istotnego ograniczenia funkcji Pakietu, za który
                  Organizacja płaci. O wycofaniu istotnej funkcji Licencjodawca
                  informuje z co najmniej 30-dniowym wyprzedzeniem.
                </li>
                <li>
                  Licencjodawca nie ponosi odpowiedzialności za:
                  <ol>
                    <li>
                      treść i poprawność danych, w tym danych osobowych,
                      zapisywanych w Oprogramowaniu przez Użytkowników, oraz
                      wyciągów, wydruków i zestawień tworzonych na ich
                      podstawie;
                    </li>
                    <li>
                      skutki naruszenia przez Organizację lub jej Użytkowników
                      przepisów prawa, w tym rozporządzenia w sprawie wzorcowego
                      regulaminu strzelnic, lub zasad korzystania z
                      Oprogramowania;
                    </li>
                    <li>
                      błędy wynikające z działania złośliwego oprogramowania,
                      oprogramowania osób trzecich, sprzętu lub sieci
                      Organizacji;
                    </li>
                    <li>
                      niedostępność Oprogramowania spowodowaną awarią dostawców
                      infrastruktury lub siłą wyższą;
                    </li>
                    <li>
                      utracone korzyści oraz szkody pośrednie, w tym wynikłe z
                      zakłócenia działalności lub utraty informacji
                      gospodarczych.
                    </li>
                  </ol>
                </li>
                <li>
                  Całkowita odpowiedzialność Licencjodawcy z tytułu Umowy jest
                  ograniczona do sumy opłat za Subskrypcję zapłaconych przez
                  Organizację w okresie 12 miesięcy poprzedzających zdarzenie
                  wywołujące szkodę. W zakresie dopuszczalnym przez prawo
                  wyłącza się odpowiedzialność Licencjodawcy z tytułu rękojmi.
                  Ograniczenia te nie dotyczą szkód wyrządzonych umyślnie.
                </li>
              </ol>
            </li>
            <li>
              Dane osobowe
              <ol>
                <li>
                  Role Licencjodawcy i Organizacji w przetwarzaniu danych
                  osobowych - w tym to, dla których kategorii danych Organizacja
                  jest administratorem, a Licencjodawca podmiotem
                  przetwarzającym - określa sekcja „Role w przetwarzaniu danych”
                  Polityki prywatności dostępnej pod adresem
                  https://celpal.net/polityka-prywatnosci. Powierzenie
                  przetwarzania danych, dla których administratorem jest
                  Organizacja, reguluje Umowa powierzenia.
                </li>
                <li>
                  Organizacja zapewnia, że wprowadza do Oprogramowania dane
                  osobowe zgodnie z prawem, w szczególności że realizuje wobec
                  osób, których dane dotyczą, obowiązki informacyjne wynikające
                  z RODO oraz z rozporządzenia w sprawie wzorcowego regulaminu
                  strzelnic.
                </li>
              </ol>
            </li>
            <li>
              Reklamacje
              <ol>
                <li>
                  Reklamacje dotyczące Oprogramowania lub rozliczeń należy
                  zgłaszać na adres e-mail kontakt@celpal.net lub pisemnie na
                  adres siedziby Licencjodawcy, podając nazwę Organizacji, adres
                  e-mail Administratora Organizacji, opis problemu oraz
                  oczekiwany sposób jego rozwiązania.
                </li>
                <li>
                  Licencjodawca rozpatruje reklamację w terminie 14 dni od jej
                  otrzymania i odpowiada na adres e-mail, z którego została
                  zgłoszona, lub na adres e-mail Administratora Organizacji.
                  Jeżeli rozpatrzenie reklamacji wymaga dodatkowych informacji,
                  Licencjodawca zwraca się o nie, a termin biegnie od ich
                  otrzymania.
                </li>
                <li>
                  Zgłoszone błędy Oprogramowania Licencjodawca usuwa bez zbędnej
                  zwłoki, stosownie do ich wpływu na możliwość korzystania z
                  Oprogramowania; błędy uniemożliwiające prowadzenie książki
                  rejestru pobytu na strzelnicy traktowane są priorytetowo.
                </li>
              </ol>
            </li>
            <li>
              Siła wyższa
              <ol>
                <li>
                  Żadna ze Stron nie odpowiada za niewykonanie lub nienależyte
                  wykonanie Umowy spowodowane siłą wyższą, to jest zdarzeniem
                  zewnętrznym o charakterze nadzwyczajnym, któremu nie można
                  zapobiec nawet przy zachowaniu najwyższej staranności, w
                  szczególności klęską żywiołową, wojną, strajkiem generalnym
                  lub awarią infrastruktury telekomunikacyjnej o zasięgu
                  krajowym.
                </li>
                <li>
                  Strona dotknięta siłą wyższą niezwłocznie informuje o tym
                  drugą Stronę i dokłada starań, aby ograniczyć jej skutki dla
                  wykonywania Umowy.
                </li>
              </ol>
            </li>
            <li>
              Czas trwania i rozwiązanie Umowy
              <ol>
                <li>
                  Organizacja może rozwiązać Umowę w każdym czasie, anulując
                  Subskrypcję w Oprogramowaniu i zgłaszając Licencjodawcy na
                  adres kontakt@celpal.net żądanie usunięcia Konta Organizacji.
                  Rozwiązanie następuje z końcem bieżącego Okresu
                  rozliczeniowego, a w razie braku Subskrypcji - z chwilą
                  otrzymania żądania.
                </li>
                <li>
                  Licencjodawca może rozwiązać Umowę z zachowaniem miesięcznego
                  okresu wypowiedzenia, ze skutkiem na koniec Okresu
                  rozliczeniowego, informując o tym Administratora Organizacji
                  e-mailem.
                </li>
                <li>
                  Licencjodawca może rozwiązać Umowę ze skutkiem natychmiastowym
                  lub zablokować dostęp do Oprogramowania, jeżeli Organizacja
                  lub jej Użytkownik rażąco narusza Regulamin, w szczególności
                  pkt 6.3, korzysta z Oprogramowania w sposób zagrażający jego
                  bezpieczeństwu lub innym Organizacjom albo podała nieprawdziwe
                  dane rejestrowe i nie uzupełniła ich mimo wezwania.
                </li>
                <li>
                  Przed rozwiązaniem Umowy Organizacja może pobrać wpisy z
                  książki rejestru pobytu i listę kont za pomocą funkcji
                  eksportu dostępnych w Oprogramowaniu. Po rozwiązaniu Umowy
                  Licencjodawca usuwa lub anonimizuje dane Organizacji na jej
                  żądanie, w terminie 30 dni od jego otrzymania, z wyjątkiem
                  danych, których dalsze przechowywanie jest wymagane przepisami
                  prawa (w szczególności dokumentów księgowych).
                </li>
              </ol>
            </li>
            <li>
              Zmiany Regulaminu
              <ol>
                <li>
                  Licencjodawca może zmienić Regulamin z ważnych przyczyn, w
                  szczególności zmiany przepisów prawa, zmiany zakresu lub
                  sposobu świadczenia usług, zmiany Operatora płatności lub
                  konieczności zapewnienia bezpieczeństwa Oprogramowania.
                </li>
                <li>
                  O zmianie Regulaminu Licencjodawca informuje Administratora
                  Organizacji e-mailem oraz w Oprogramowaniu co najmniej 14 dni
                  przed jej wejściem w życie, publikując jednocześnie nową treść
                  Regulaminu w Serwisie. Zmiany wynikające wyłącznie z przepisów
                  prawa lub niepogarszające sytuacji Organizacji mogą wejść w
                  życie bez zachowania tego terminu.
                </li>
                <li>
                  Organizacja, która nie akceptuje zmiany, może rozwiązać Umowę
                  do dnia jej wejścia w życie na zasadach z pkt 12.1. Dalsze
                  korzystanie z Oprogramowania po tym dniu oznacza akceptację
                  zmienionego Regulaminu.
                </li>
              </ol>
            </li>
            <li>
              Postanowienia końcowe
              <ol>
                <li>
                  Umowa podlega prawu polskiemu. W sprawach nieuregulowanych
                  stosuje się przepisy Kodeksu cywilnego, ustawy o prawie
                  autorskim i prawach pokrewnych oraz ustawy o świadczeniu usług
                  drogą elektroniczną.
                </li>
                <li>
                  Spory wynikające z Umowy Strony będą starały się rozwiązać
                  polubownie, a w razie braku porozumienia rozstrzygać je będzie
                  sąd powszechny właściwy dla siedziby Licencjodawcy.
                </li>
                <li>
                  Jeżeli którekolwiek postanowienie Regulaminu okaże się
                  nieważne lub niewykonalne, pozostałe postanowienia pozostają w
                  mocy, a w miejsce postanowienia nieważnego stosuje się przepis
                  prawa najbliższy jego celowi.
                </li>
              </ol>
            </li>
          </ol>
        </Content>
      </Box>
    </PageSkeleton>
  )
}
